import { render } from "./ErrorNotebookInner.vue?vue&type=template&id=883dfb26&scoped=true"
import script from "./ErrorNotebookInner.vue?vue&type=script&lang=js"
export * from "./ErrorNotebookInner.vue?vue&type=script&lang=js"

import "./ErrorNotebookInner.vue?vue&type=style&index=0&id=883dfb26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-883dfb26"]])

export default __exports__